<template>
<div>
  <div class="sub-header-container">
    <div class="sub-header-content" style="justify-content: center;">
      <div class="page-title-container" style="padding-top:40px; padding-bottom: 40px;">
        <div class="page-title" style="text-align: center;">Welcome back! 👋</div>
      </div>
    </div>
  </div>

  <div class="page-container">
    <Login @logged="$router.push({ path: '/' })"/>
  </div>
</div>
</template>

<script>
import Login from '@/components/Login'

export default {
  name: 'LoginView',

  components: {
    Login,
  },

  data() {
    return {
      router: this.$router,
      showEmailBadFormat: false,
      showMissingError: false,
      showLoginError: false,
      email: '',
      password: '',
    }
  },
}
</script>

<style scoped>
.p-error {
  color: red;
}

.header-container{
  background-color: var(--global-header-color);
  max-width: 1100px;
  padding: 10px 3rem 10px 3rem;
  margin: 0 auto;
}
.sub-header-container{
  background-color: transparent;
  max-width: 1100px;
  padding: 0 3rem;
  margin: 0 auto 10px auto;
}
.page-container{
  max-width: 1100px;
  padding: 0 3rem;
  margin: 0 auto;
}
@media (max-width: 760px){
  .header-container{
  padding: 0 0.5rem;
  }
  .sub-header-container{
  padding: 0 0.5rem;
  }
  .page-container{
  padding: 0 0.5rem;
  }
  .website-name{
    font-size: 15px;
  }
   .website-name-container img{
    width: 22px;
  }
  .website-name-container p{
    display: none;
  }
}
</style>
